import { render, staticRenderFns } from "./PraiseAndWorship.vue?vue&type=template&id=7fe7db83&"
import script from "./PraiseAndWorship.vue?vue&type=script&lang=js&"
export * from "./PraiseAndWorship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports